const doc = [({"da":({"js":({"admin":({"economy":({"index":({"economy":"Økonomi"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;